// This file is part of re-motion
// Copyright (c) rubicon IT GmbH, www.rubicon.eu
// 
import { ILogger } from "@lib/logging/ILogger";
import { IRemoteLogMessageSender } from "@lib/logging/IRemoteLogMessageSender";
import { LogLevel } from "@lib/logging/LogLevel";

/**
 * Provides methods for logging messages to a remote location.
 * Trace messages are not logged remotely.
 */
export class RemoteLogger implements ILogger {
  readonly remoteLogMessageSender: IRemoteLogMessageSender;

  private skipLogging = false;

  enabled = true;
  logLevel: LogLevel;

  constructor(remoteLogMessageSender: IRemoteLogMessageSender, logLevel: LogLevel) {
    this.remoteLogMessageSender = remoteLogMessageSender;
    this.logLevel = logLevel;
  }

  log(logLevel: LogLevel, format: string, args: any[]): void {
    if (!this.enabled || this.skipLogging)
      return;

    if (logLevel < this.logLevel)
      return;

    // Trace messages are not logged via remote logging
    if (logLevel === LogLevel.All)
      return;

    try {
      this.remoteLogMessageSender.sendLogMessage(logLevel, format, args);
    }
    finally {
      this.skipLogging = false;
    }
  }
}